import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

import cache from './modules/cache/cache'
import filters from './modules/filters/filters'
import cms from './modules/cms/cms'

Vue.use(Vuex)

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    cache,
    filters,
    cms
  }
})

export default store
